<template>
  <div class="content" v-loading.fullscreen.lock="loading">
    <!-- <base-header class="pb-6">
      <div class="row align-items-center py-2">
        <div class="col-lg-6 col-7"></div>
      </div>
    </base-header> -->
    <div class="add-tutorial-video">
      <card>
        <!-- Card header -->
        <h2 slot="header" class="mb-0" v-if="this.video_id">
          Edit Tutorial Video
        </h2>
        <h2 slot="header" class="mb-0" v-else>
          Add Tutorial Video
        </h2>
        <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
          <form
            class="needs-validation general-form"
            @submit.prevent="handleSubmit()"
            enctype="multipart/form-data"
          >
            <div class="row">
              <div class="col-md-6">
                <label class="form-control-label">Role <span class="requireField">*</span></label>
                <br />
                <el-select
                  class="select-primary w-100"
                  v-model="vid.role"
                  placeholder="Role"
                  rules="required"
                  multiple
                >
                  <el-option
                    class="select-primary"
                    v-for="(option, index) in roles"
                    :value="option.value"
                    :label="option.label"
                    :key="'roles_' + index"
                  >
                  </el-option>
                </el-select>
              </div>

              <div class="col-md-6">
                <base-input
                  name="Video Title"
                  placeholder="Video Title"
                  rules="required"
                  v-model="vid.video_name"
                >
                <template #label>
                  <label>
                    Video Title <span class="requireField">*</span>
                  </label>
                </template>
                </base-input>
              </div>
              <div class="col-md-6">
                <base-input
                  label="Video Description"
                  name="Video Description"
                  placeholder="Video Description"
                  v-model="vid.video_description"
                >
                </base-input>
              </div>
              <div class="col-md-6">
                <base-input
                  name="Video Id"
                  placeholder="Video Id"
                  rules="required"
                  v-model="vid.video"
                >
                <template #label>
                  <label>
                    Video Id <span class="requireField">*</span>
                  </label>
                </template>
                </base-input>
              </div>
              <div class="col-md-6 custom-upload-wrap">
                <label class="form-control-label">Image</label>
                  <form>
                    <file-input accept="image/png, image/jpeg"  v-on:change="onCourseImage"></file-input>
                  </form>
              </div>
            </div>
            <div class="text-right">
              <base-button type="danger" class="greybtn font-weight-normal px-5 mr-1 mr-sm-3" @click="$router.go(-1)"
                >Cancel</base-button
              >
              <base-button type="primary" class="font-weight-normal px-5" @click.prevent="saveVideos()"
                >Submit</base-button
              >
            </div>
          </form>
        </validation-observer>
      </card>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import Swal from "sweetalert2/dist/sweetalert2.js";
import FileInput from "@/components/Inputs/FileInput";
import "sweetalert2/src/sweetalert2.scss";
export default {
  components: {
    FileInput,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      hot_user: "",
      hot_token: "",
      config: "",
      video_id: "",
      vid: {
        role: [],
        video_name: "",
        video: "",
        video_description: ""
      },
      roles: [
        {
          label: "Company Admin",
          value: "1"
        },
        {
          label: "Employee",
          value: "2"
        },
        {
          label: "Manager",
          value: "3"
        }
      ],
      image:""
    };
  },
  created() {
    if (localStorage.getItem("hot-token")) {
      this.hot_user = localStorage.getItem("hot-user");
      this.hot_token = localStorage.getItem("hot-token");
    }

    if (this.$route.query.id) {
      this.video_id = this.$route.query.id;
      this.$http.get("employees/tutorialVideos/" + this.video_id).then(resp => {
        let data = resp.data;
        this.vid.role.push(data.role);
        this.vid.video_name = data.video_title;
        this.vid.video_description = data.video_description;
        this.vid.video = data.video;
      });
    }
  },

  methods: {
    onCourseImage(e){
      let files = e;
      this.image = files[0];
      // console.log(this.image);
    },
    saveVideos() {
  if (
    this.vid.role.length > 0 && // Handles multiple roles as before
    this.vid.video_name !== "" &&
    this.vid.video !== "" // Mandatory fields
  ) {
    const formData = new FormData();
    this.vid.role.forEach((role, index) => {
      formData.append(`role[${index}]`, role);
    });
    formData.append("video_name", this.vid.video_name);
    formData.append("video_description", this.vid.video_description);
    formData.append("video", this.vid.video);

    // Append image only if it exists
    if (this.image) {
      formData.append("image", this.image);
    }

    const config = {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    };

    if (this.video_id !== "") {
      // Update existing video
      formData.append("video_id", this.video_id); // Append video ID for updates
      this.$http
        .post(`employees/tutorialVideo/${this.video_id}`, formData, config)
        .then(resp => {
          Swal.fire({
            title: "Success!",
            text: `Video Has been Updated!`,
            icon: "success",
            confirmButtonClass: 'btn btn-success',
                                confirmButtonText: 'Ok'
          });
          this.$router.push("/tutorial_video");
        });
    } else {
      // Add new video
      this.$http
        .post("employees/addtutorialVideo", formData, config)
        .then(resp => {
          Swal.fire({
            title: "Success!",
            text: `Video Has been Added!`,
            icon: "success",
            confirmButtonClass: 'btn btn-success',
                                confirmButtonText: 'Ok'
          });
          this.$router.push("/tutorial_video");
        });
    }
  } else {
    return Swal.fire({
      title: "Error!",
      text: `Please Fill all the mandatory fields!`,
      icon: "error",
      confirmButtonClass: 'btn btn-success',
                                confirmButtonText: 'Ok'
    });
  }
}


  }
};
</script>
<style>
.stripe-card {
  border: 1px solid grey;
}
.stripe-card.complete {
  border-color: green;
}
.logo-size {
  width: 60%;
  height: auto;
}
</style>
